 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import A_STORM_IN_THE_STARSFINALHC20 from '@/components/A_Storm_in_the_Stars.FINALHC20'
 import A_STORM_IN_THE_STARSFINALHC37 from '@/components/A_Storm_in_the_Stars.FINALHC37'
 import A_STORM_IN_THE_STARSFINALHC21 from '@/components/A_Storm_in_the_Stars.FINALHC21'
 import A_STORM_IN_THE_STARSFINALHC22 from '@/components/A_Storm_in_the_Stars.FINALHC22'
 import A_STORM_IN_THE_STARSFINALHC23 from '@/components/A_Storm_in_the_Stars.FINALHC23'
 import A_STORM_IN_THE_STARSFINALHC25 from '@/components/A_Storm_in_the_Stars.FINALHC25'
 import A_STORM_IN_THE_STARSFINALHC27 from '@/components/A_Storm_in_the_Stars.FINALHC27'
 import A_STORM_IN_THE_STARSFINALHC28 from '@/components/A_Storm_in_the_Stars.FINALHC28'
 import A_STORM_IN_THE_STARSFINALHC30 from '@/components/A_Storm_in_the_Stars.FINALHC30'
 import A_STORM_IN_THE_STARSFINALHC31 from '@/components/A_Storm_in_the_Stars.FINALHC31'
 import A_STORM_IN_THE_STARSFINALHC32 from '@/components/A_Storm_in_the_Stars.FINALHC32'
 import A_STORM_IN_THE_STARSFINALHC33 from '@/components/A_Storm_in_the_Stars.FINALHC33'
 import A_STORM_IN_THE_STARSFINALHC34 from '@/components/A_Storm_in_the_Stars.FINALHC34'
 import A_STORM_IN_THE_STARSFINALHC35 from '@/components/A_Storm_in_the_Stars.FINALHC35'
 import A_STORM_IN_THE_STARSFINALHC36 from '@/components/A_Storm_in_the_Stars.FINALHC36'
 import LOVE_2 from '@/components/love_2'
 import A_STORM_IN_THE_STARSFINALHC38 from '@/components/A_Storm_in_the_Stars.FINALHC38'
 import ABOUTAUTHOR from '@/components/aboutauthor'
 import UNTITLED22 from '@/components/Untitled22'
 import DELPHINIUM from '@/components/delphinium'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/A_Storm_in_the_Stars.FINALHC20",
 			"name" : "A_Storm_in_the_Stars.FINALHC20",
 			"component" : A_STORM_IN_THE_STARSFINALHC20
 		},
 		{
 			"path" : "/A_Storm_in_the_Stars.FINALHC37",
 			"name" : "A_Storm_in_the_Stars.FINALHC37",
 			"component" : A_STORM_IN_THE_STARSFINALHC37
 		},
 		{
 			"path" : "/A_Storm_in_the_Stars.FINALHC21",
 			"name" : "A_Storm_in_the_Stars.FINALHC21",
 			"component" : A_STORM_IN_THE_STARSFINALHC21
 		},
 		{
 			"path" : "/A_Storm_in_the_Stars.FINALHC22",
 			"name" : "A_Storm_in_the_Stars.FINALHC22",
 			"component" : A_STORM_IN_THE_STARSFINALHC22
 		},
 		{
 			"path" : "/A_Storm_in_the_Stars.FINALHC23",
 			"name" : "A_Storm_in_the_Stars.FINALHC23",
 			"component" : A_STORM_IN_THE_STARSFINALHC23
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js